import schema from '../form-configs/schema';
import data from '../form-configs/data';
import layout from '../form-configs/layout';

export const adjustInfo = context => ({
  schema: {
    ...schema(context),
  },
  formModel: {
    ...data,
  },
  layout: {
    ...layout,
  },
});

export default adjustInfo;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/adjust-info.js